module.exports = __webpack_public_path__ + "static/media/avvioLogo.59e15dfa.webp";